import React, { useContext } from "react";
import { observer } from "mobx-react";

import { OfferStoreContext } from "@gp/components";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";

import { MyBetsBody } from "./MyBetsBody";

export const MyBetsContent = observer(function MyBetsContent() {
	const store = useContext(OfferStoreContext) as EventViewStore;

	if (store.currentTab === EventBodyTabs.MyBets) {
		return <MyBetsBody />;
	}

	return null;
});
